import React from 'react';
import PropTypes from 'prop-types';

const LoadSpinner = ({ className, loadTitle, loadText, ...props }) => (
  <div
    className={className}
    data-testid="load-spinner"
    {...props}
    role="img"
    aria-label="Loader"
  >
    <div className="loadWrap">
      {!!loadText && <div className="loadText">{loadText}</div>}
      <div className="loader">{loadTitle}</div>
    </div>
  </div>
);

LoadSpinner.propTypes = {
  className: PropTypes.string,
  loadText: PropTypes.string,
  loadTitle: PropTypes.string,
};

LoadSpinner.defaultProps = {
  className: '',
  loadText: '',
  loadTitle: '',
};

export default LoadSpinner;
